export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const appId = config.public.intercomAppId

  if (!appId) {
    console.warn('[Intercom] Missing NUXT_PUBLIC_INTERCOM_APP_ID')
    return
  }

  let scriptLoaded = false
  let isBooted = false

  function loadIntercomScript() {
    if (scriptLoaded) return
    scriptLoaded = true

    const script = document.createElement('script')
    script.id = 'intercom-script'
    script.type = 'text/javascript'
    script.async = true
    script.src = `https://widget.intercom.io/widget/${appId}`

    const firstScript = document.getElementsByTagName('script')[0]
    firstScript.parentNode?.insertBefore(script, firstScript)

    window.Intercom =
      window.Intercom ||
      function (...args: any[]) {
        ;(window.Intercom.q = window.Intercom.q || []).push(args)
      }
  }

  nuxtApp.provide('intercom', {
    boot: (user: any, showLauncher = false) => {
      if (!user?.email) return
      loadIntercomScript()

      window.Intercom('boot', {
        app_id: appId,
        api_base: 'https://api-iam.eu.intercom.io',
        email: user.email,
        name: user.name,
        hide_default_launcher: !showLauncher,
      })

      window.Intercom('update', {
        intercom_user_jwt: user.intercom_user_jwt,
      })

      if (!showLauncher) {
        window.Intercom('hide')
      }

      isBooted = true
    },
    show: () => window.Intercom?.('show'),
    hide: () => window.Intercom?.('hide'),
    showNewMessage: (msg?: string) => window.Intercom?.('showNewMessage', msg ?? ''),
    update: (attrs: Record<string, any>) => window.Intercom?.('update', attrs),
    shutdown: () => {
      window.Intercom?.('shutdown')
      isBooted = false
    },
    isBooted: () => isBooted,
  })
})

declare global {
  interface Window {
    Intercom?: (...args: any[]) => void
  }
}

declare module '#app' {
  interface NuxtApp {
    $intercom: {
      boot: (user: any, showLauncher?: boolean) => void
      show: () => void
      hide: () => void
      showNewMessage: (message?: string) => void
      update: (settings: Record<string, any>) => void
      shutdown: () => void
      isBooted: () => boolean
    }
  }
}
